import { Component,ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { LayoutsProvider } from '../../providers/layouts/layouts';
import { ModelsPage } from '../models/models';

/**
 * Generated class for the LayoutPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-layout',
  templateUrl: 'layout.html',
})
export class LayoutPage {
  project:any;
  layouts:any;
  page:any = "0";
  categories:any = null;
  selected_index:any = null;
  selected_type:any = null;
  @ViewChild("segments") segments;

  constructor(
    private layoutsProvider: LayoutsProvider,
    public navCtrl: NavController,
    public navParams: NavParams
  ) {
    this.project = this.navParams.get('project');
  }

  ionViewDidEnter(){
  }

  selectScreenshot(type, index){
    this.selected_type = type;
    this.selected_index = index;
  }


  ionViewDidLoad() {
    this.categories = this.layoutsProvider.getCategories();
    this.page = "0";
    // if (this.segments) {
    //     this.segments.ngAfterViewInit();
    // }
    this.layouts = this.layoutsProvider.getLayouts();
    // console.log('ionViewDidLoad LayoutPage');
  }

  goToEditor(){
    this.navCtrl.push(ModelsPage,{project:this.project, layout_type: this.selected_type,layout_index: this.selected_index});
  }

  // On slide changed
  selectedTab() {
    this.centerScroll();
  }

  // Center current scroll
  centerScroll(){
    if(!this.segments || !this.segments.nativeElement)
      return;

    let sizeLeft = this.sizeLeft();
    let sizeCurrent = this.segments.nativeElement.children[this.page].clientWidth;
    let result = sizeLeft - (window.innerWidth / 2) + (sizeCurrent/2) ;

    result = (result > 0) ? result : 0;
    this.smoothScrollTo(result);
  }

  // Get size start to current
  sizeLeft(){
    let size = 0;
    for(let i = 0; i < this.page; i++){
      size+= this.segments.nativeElement.children[i].clientWidth;
    }
    return size;
  }

  // Easing function
  easeInOutQuart(time, from, distance, duration) {
    if ((time /= duration / 2) < 1) return distance / 2 * time * time * time * time + from;
    return -distance / 2 * ((time -= 2) * time * time * time - 2) + from;
  }

  // Animate scroll
  smoothScrollTo(endX){
    let startTime = new Date().getTime();
    let startX = this.segments.nativeElement.scrollLeft;
    let distanceX = endX - startX;
    let duration = 400;

    let timer = setInterval(() => {
      var time = new Date().getTime() - startTime;
      var newX = this.easeInOutQuart(time, startX, distanceX, duration);
      if (time >= duration) {
        clearInterval(timer);
      }
      this.segments.nativeElement.scrollLeft = newX;
    }, 1000 / 60); // 60 fps
  }

}



// WEBPACK FOOTER //
// ./src/pages/layout/layout.ts